import { createAction } from "@reduxjs/toolkit";
import { SelectedMenu } from "src/types/common";

export const clearAllStores = createAction("clearAllStores");
export const onSelectMenu = createAction<SelectedMenu>("onSelectMenu");
